import {Component, inject} from '@angular/core';
import {BadgeModule} from 'primeng/badge';
import {OverlayBadgeModule} from 'primeng/overlaybadge';

import {BellNotification} from './components/bell-notification/bell-notification';
import {MyProfile} from './components/profile/my-profile.component';
import {TimesheetTimer} from './components/timesheet-timer/timesheet-timer';
import {InvoicingAlert} from './components/invoicing-alert/invoicing-alert';
import {CanAccessFinances} from '../../directives/can-access-finances';
import {CurrentUserService} from '../../services/current-user.service';


@Component({
  selector: 'elcia-header',
  imports: [
    OverlayBadgeModule,
    BadgeModule,
    BellNotification,
    MyProfile,
    TimesheetTimer,
    InvoicingAlert,
    CanAccessFinances,
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  protected readonly currentUserService = inject(CurrentUserService);
}
